'use strict';

const config = {
    containerSelector: '.u-disable-until-checked',
    triggerSelector: '.js-disable-submit-until-checked',
    disabledClass: 'c-button--disabled',
    targetType: 'input[type=submit], button[type=submit]'
};

$(config.triggerSelector).change(function() {
    const $container = $(config.containerSelector);
    const $button = $container.find('.' + config.disabledClass);

    if (this.checked) {
        $button.removeAttr('disabled').removeClass(config.disabledClass);
    } else if (!this.checked) {
        $container.find(config.targetType).addClass(config.disabledClass);
        $container.find(config.targetType).attr('disabled', true);
    }
});



// WEBPACK FOOTER //
// ./src/js/components/on-checkbox-select.js